export default __webpack_public_path__ + "static/media/live_as_mentor.e8fb694f.svg";